









































































































import Vue from 'vue'
import { mapGetters } from 'vuex'

import Chart from '@/components/admin/Chart.vue'
import DateRangePicker from '@/components/DateRangePicker.vue'

import { NetworkService } from '../../services/NetworkService'

export default Vue.extend({

  data() {
    return {
      behaviourData: null,
      loading: false,
      chartType: 'line',
      chartOptions: {
        responsive: true
      }
    }
  },
  computed: {
    ...mapGetters({
      currentDealer: 'dealers/currentDealer',
    }),
    basicStatistics() : Object | null {
      if (this.behaviourData !== null) {
        const statistics = {
          pageViews: this.behaviourData.report.reports[0].data.totals[0].values[0] as number,
          uniquePageViews: this.behaviourData.report.reports[0].data.totals[0].values[1] as number,
          avgTimeOnPage: this.behaviourData.report.reports[0].data.totals[0].values[2] as number,
          bounceRate: this.behaviourData.report.reports[0].data.totals[0].values[3] as number
        }
        return statistics
      } else {
        const statistics = {
          pageViews: 0 as number,
          uniquePageViews: 0 as number,
          avgTimeOnPage: 0 as number,
          bounceRate: 0 as number
        }

        return statistics
      }
    },
    chartData() : Object {
      if (this.behaviourData !== null) {
        return {
          labels: this.chartLabels,
          datasets: [{
            label: 'Page Views',
            backgroundColor: 'rgb(255, 99, 132)',
            borderColor: 'rgb(255, 99, 132)',
            data: this.chartXData,
            tension: 0.3
          }]  
        }
      } else { return null }
    },
    chartXData() : Array<number> {
      let chartXData : Array<number> = []
      const data = this.behaviourData.report.reports[0].data.rows.flat()
      data.forEach((row: any) => {
        chartXData.push(row.metrics[0].values[0])
      })
      return chartXData
    },
    chartLabels() : Array<string> {
      let labels : Array<string> = []
      const data = this.behaviourData.report.reports[0].data.rows.flat()
      data.forEach((row: any) => {
        let combinedString = ''
        row.dimensions.forEach((el: string) => {
          combinedString = combinedString + '-' + el
        })
        labels.push(combinedString.substring(1))
      })
      return labels
    }
  },
  methods: {
    async getBehaviourData([start, end] : string[]) {
      this.loading = true

      const res = await NetworkService.get(
        process.env.VUE_APP_API_BASE_URL +
        '/api/v1/auth/analytics/getBehaviour?startDate=' + start + '&endDate=' + end + '&dealer=' + this.currentDealer.code
      )

      this.behaviourData = res.data
      this.loading = false
    },
  },
  components: {
    Chart,
    DateRangePicker
  }
})
